import HomeBanner from './HomeBanner'
import HomeBigimage from './HomeBigimage'
import HomeConnect from './HomeConnect'
import HomeCounter from './HomeCounter'
import HomeFounder from './HomeFounder'
import HomeManufacture from './HomeManufacture'
import HomeProject from './HomeProject'
import HomeService from './HomeService'
import HomeTeam from './HomeTeam'
import HomeTestimonial from './HomeTestimonial'

export default function Home({ initialData }) {
  return (
    <>
      <HomeBanner/>
      <HomeFounder/>
      <HomeProject initialProjects={initialData?.projects} />
      <HomeService/>
      <HomeTestimonial/>
      <HomeCounter/>
      <HomeManufacture/> 
      <HomeTeam/>
      <HomeBigimage/>
      <HomeConnect/>
    </>
  )
}
